import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { speedFeatures } from "@/mocks/home";

export default function SpeedSection() {
  return (
    <section id="speed" className="w-full bg-background-100 py-14 md:py-20">
      <div className="max-w-content mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <Reveal>
            <div className="relative w-full aspect-video rounded-lg overflow-hidden bg-background-900">
              <img
                src="https://readdy.ai/api/search-image?query=dark%20cinematic%20streaming%20player%20interface%20background%20with%20a%20warm%20amber%20light%20beam%20across%20a%20deep%20crimson%20abstract%20scene%2C%20soft%20film%20grain%2C%20blurred%20elegant%20texture%2C%20no%20text%2C%20no%20logos%2C%20premium%20moody%20atmosphere&width=1280&height=720&seq=shenma-speed-player&orientation=landscape"
                alt="神马电影网 极速播放器界面示意"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>

              <span className="absolute top-4 left-4 px-2.5 py-1 rounded-md bg-primary-500 text-background-50 text-xs font-medium">
                <i className="ri-flashlight-fill mr-1"></i>
                极速起播 0.8s
              </span>
              <span className="absolute top-4 right-4 px-2.5 py-1 rounded-md bg-background-50/90 text-foreground-800 text-xs font-medium">
                4K HDR · 无广告
              </span>

              <button
                type="button"
                className="absolute inset-0 m-auto w-16 h-16 flex items-center justify-center rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer"
                aria-label="播放演示"
              >
                <i className="ri-play-fill text-3xl"></i>
              </button>

              <div className="absolute bottom-4 left-4 right-4">
                <div className="h-1 rounded-full bg-background-50/30 overflow-hidden">
                  <div className="h-full w-2/5 rounded-full bg-accent-500"></div>
                </div>
                <div className="mt-2 flex items-center justify-between text-[11px] text-background-200">
                  <span>已观看 42:16 / 1:48:30</span>
                  <span><i className="ri-history-line mr-1"></i>自动续看已开启</span>
                </div>
              </div>
            </div>
          </Reveal>

          <div>
            <Reveal>
              <SectionHeading
                eyebrow="极速观看"
                title="从点开到画面出现，不用等"
                desc="播放链路的目标只有一个：让你尽快看到正片。以下是影响起播速度与观看连续性的几个关键点。"
              />
            </Reveal>

            <div className="mt-8 space-y-4">
              {speedFeatures.map((item, index) => (
                <Reveal key={item.id} delay={index * 70}>
                  <div className="flex gap-4 rounded-lg bg-background-50 border border-background-200 p-4">
                    <span className="w-10 h-10 shrink-0 flex items-center justify-center rounded-md bg-primary-100 text-primary-600">
                      <i className={`${item.icon} text-lg`}></i>
                    </span>
                    <div>
                      <h3 className="text-sm font-bold text-foreground-950">{item.title}</h3>
                      <p className="mt-1 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}